import React from "react";
import classes from "./SubtitleTypeA.module.scss";

const SubtitleTypeA: React.FC<{ title: string; text: string }> = ({
  title,
  text,
}) => {
  return (
    <div className={classes.container}>
      <h2 className={classes.title}>{title}</h2>
      <p className={classes.text}>{text}</p>
    </div>
  );
};

export default SubtitleTypeA;
